import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
function generateAvatarUrl(user) {
  if (user.avatar) {
    return user.avatar;
  }
  const name = user.name || user.handle || "User";
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&size=48&background=random`;
}
export {
  cn,
  generateAvatarUrl
};
//# sourceMappingURL=utils.js.map
